import firebase from 'firebase/app';
import 'firebase/firestore';
import { logger } from 'logging';

import { DocumentName, DefaultCollection } from './constants';
import { isCypress } from '../../../shared/helpers/utils/cypress';

interface Config {
  [key: string]: string;
}

export const listenCloudStore = (
  config: Config,
  actionCB: (data: any) => Promise<void>
) => {
  try {
    if (firebase && !isCypress()) {
      if (!firebase.apps.length) {
        firebase.initializeApp(config || {});
      }
      const dataBaseRef = firebase.firestore();
      if (dataBaseRef) {
        const fireStoreCollection = config?.collection || DefaultCollection;
        const docName = config?.doc || DocumentName;
        const docRef = dataBaseRef.collection(fireStoreCollection).doc(docName);
        docRef.onSnapshot((doc: any) => {
          const data = doc.data();
          actionCB && actionCB(data);
        });
      }
    }
  } catch (e) {
    logger.error(e, 'Error in firebase listener');
  }
};
